export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14413.b0e5ede4.jpg";